import {Layout, LayoutScrollable} from '@di-nxt/components';
import React, {useCallback} from 'react';
import {TeamMember} from '../../../services';
import {MemberItem} from './MemberItem';

type Props = {
  members: TeamMember[];
  onSelectMember: (member: TeamMember) => void;
  onRemove: (member: TeamMember) => void;
};

export const MemberList: React.FC<Props> = ({
  members,
  onSelectMember,
  onRemove: onMorePress,
}) => {
  const handleMorePressed = useCallback(
    (t: string) => {
      members.forEach(member => {
        if (member.mobileNo === t) {
          onMorePress(member);
        }
      });
    },
    [members, onMorePress],
  );

  const handleSelectMember = useCallback(
    (id: number) => {
      const member = members.find(m => m.membershipId === id);
      if (member) {
        onSelectMember && onSelectMember(member);
      }
    },
    [members, onSelectMember],
  );

  return (
    <LayoutScrollable>
      <Layout vertical flex padding="20">
        {members.map(m => (
          <MemberItem
            key={m.personId}
            member={m}
            onMemberSelect={handleSelectMember}
            onDeleteUser={handleMorePressed}
          />
        ))}
      </Layout>
    </LayoutScrollable>
  );
};
